import { render, staticRenderFns } from "./CogMenu.vue?vue&type=template&id=fdd057e2&scoped=true"
import script from "./CogMenu.vue?vue&type=script&lang=ts"
export * from "./CogMenu.vue?vue&type=script&lang=ts"
import style0 from "./CogMenu.vue?vue&type=style&index=0&id=fdd057e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd057e2",
  null
  
)

export default component.exports